import {ImageOpNodeMath} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/math/node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/map-zero-one-to-minus-one-plus-one/definition"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeMapZeroOneToMinusOnePlusOne"}

@registerImageOpNode
export class ImageOpNodeMapZeroOneToMinusOnePlusOne extends CompositeImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage} = await evaluator.getAll(this.parameters)

        let current: ValueOrNode<AnyImageOpResult> = sourceImage
        current = imageOpNodeBag.getNode("mul", ImageOpNodeMath, {
            operator: "*",
            operandA: current,
            operandB: 2,
        })
        current = imageOpNodeBag.getNode("add", ImageOpNodeMath, {
            operator: "+",
            operandA: current,
            operandB: -1,
        })

        return await evaluator.get(current)
    }
}
